import {outter_post} from 'common/js/axios-helper';
import {MemberLevelApi} from "./constant/UrlMapper";

const host = '8883';


const select = (data) => {
    return outter_post(MemberLevelApi.Select, data, host);
};

const rebateType = (data) => {
    return outter_post(MemberLevelApi.RebateType, data, host);
};

const add = (data) => {
    return outter_post(MemberLevelApi.Add, data, host);
};

const del = (data) => {
    return outter_post(MemberLevelApi.Delete, data, host);
};

const selectOne = (data) => {
    return outter_post(MemberLevelApi.SelectOne, data, host);
};

const update = (data) => {
    return outter_post(MemberLevelApi.Update, data, host);
};

const updateMemRateLevelChnFee = (data) => {
    return outter_post(MemberLevelApi.UpdateMemRateLevelChnFee, data, host);
};


const listNoPage = (data) => {
    return outter_post(MemberLevelApi.ListNoPage, data, host);
};

const memLvlUp = (data) => {
    return outter_post(MemberLevelApi.MemLvlUp, data, host);
};

const accountList = (data) => {
    return outter_post(MemberLevelApi.AccountList, data, host);
};
const accountadjustmentList = (data) => {
    return outter_post(MemberLevelApi.AccountAdjustmentList, data, host);
};
const accountadjustmentEdit = (data) => {
    return outter_post(MemberLevelApi.AccountAdjustmentEdit, data, host);
};

export default {
    select, rebateType, add, del, selectOne, update, updateMemRateLevelChnFee,
    listNoPage,
    memLvlUp,
    accountList,
    accountadjustmentList,
    accountadjustmentEdit,
}



// WEBPACK FOOTER //
// ./src/service/MemberLevelService.js